import { render, staticRenderFns } from "./MyTodoList.vue?vue&type=template&id=3561aff0&scoped=true&"
import script from "./MyTodoList.vue?vue&type=script&lang=js&"
export * from "./MyTodoList.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoList.vue?vue&type=style&index=0&id=3561aff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561aff0",
  null
  
)

export default component.exports